import { useState, useEffect, useContext } from 'react';
import { GridColDef, GridToolbar, DataGrid, GridToolbarContainer, GridToolbarExport } from '@mui/x-data-grid';
import Table from '../custom/Table';
import Title from '../custom/Title';
import { Refresh } from "@mui/icons-material";
import { Button, IconButton, Tooltip, List, Box, Typography  } from "@mui/material";
import { INV_INVENTORY_SHOWCASE, transcationFields, InventoryData, MyObject, SerialNumbers, TranscationData, TransactionDetail, SerialNumbersRow } from '../../Models/Inventory';
import Modal from '../Modals';
import styled from 'styled-components';
import VisibilityIcon from '@mui/icons-material/Visibility';
import CreateStockModal from './CreateStockModal';
import useService from '../../hooks/useService';
import { fetchInventory, fetchStoInventory } from '../../services/Inventory'
import { InventoryContext } from '../../contexts/InventoryContext';
import { AuthContext } from '../../contexts/AuthContext';
import moment from 'moment';
import IssueCutBar from './InventoryAdjustment';
import { TRANSACTION_TYPES } from '../../utils/constant';

const InventoryType: any = {
    1: 'Normal SKU',
    2: 'Cut Bar/Loose Items',
    3: 'Buffing dust',
    4: 'Scrap from barter/buyback',
    5: 'Jobwork metal',
    6: 'GMS metal',
    7: 'Non-Serialized SKU'
}

const SerialNumberGrid = styled.div`
    width: 900px !important;
`

const MetalImage = styled.img`
  object-fit: contain;
  max-width: 100px;
  max-height: 45px;
  border-radius: 4px;
  padding: 3px 0;
`

export const InventoryShowcase = () => {

    const { execute } = useService()
    const { inventories } = useContext(InventoryContext)
    const { user } = useContext(AuthContext)

    const [showTranscationDetail, setShowTranscationDetail] = useState<boolean | TransactionDetail>(false)
    const [showSTOModal, setShowSTOModal] = useState<boolean | string>(false)
    const [showSerialNumberModal, setShowSerialNumberModal] = useState<InventoryData | boolean>(false)
    const [showIssueModal, setShowIssueModal] = useState<boolean | string>(false)

    const updated_at = inventories?.data && inventories.data[0]?.updatedAt
    const lastUpdatedAt = inventories?.data ? moment(updated_at).clone().utcOffset('+05:30').format('hh:mm a, Do MMM') : ''
    
    const closeTranscationDetailModal = () => {
        setShowTranscationDetail(false)
    }

    const closeSTOModal = () => {
        setShowSTOModal(false)
    }

    const closeSerialNumberModal = () => {
        setShowSerialNumberModal(false)
    }

    const closeIssueModal = () => {
        setShowIssueModal(false)
    }

    const getInventoryColumns = () => {
        let minWidth = 100

        return INV_INVENTORY_SHOWCASE.map(inboundField => {

            const row: GridColDef = {
                field: inboundField.id,
                headerName: inboundField.label,
                minWidth,
                align: 'left',
                headerAlign: 'left'
            }

            switch (inboundField.id) {
                case "image":
                    row.minWidth = 100;
                    row.filterable = false;
                    row.disableExport = true;
                    row.renderCell = params => {
                        let url = params.row.images.length > 0 ? params.row.images.sort((a: MyObject, b: MyObject) => Number(a.priority) - Number(b.priority))[0].img_url : ''
                        return url ? <MetalImage src={url} /> : <MetalImage src={'/assets/images/elementor-placeholder-image.webp'} />
                    }
                    break;
                case "name":
                    row.minWidth = 550;
                    row.type = 'string';
                    row.renderCell = params => {
                        return (
                            <Tooltip title={params.row.name ? params.row.name : "NA"}>
                              <Typography>{params.row.name ? params.row.name : "NA"}</Typography>
                            </Tooltip>
                        )
                    }
                    break;
                case "inventoryType":
                    row.minWidth = 220;
                    row.type = 'string';
                    row.valueGetter = params => {
                        // console.log("rowValue:", params.row);
                        return getInventoryType(params.row);
                    };
                    row.renderCell = params => {
                        return (
                          <Tooltip title={getInventoryType(params.row)}>
                            <Typography>
                              {getInventoryType(params.row)}
                            </Typography>
                          </Tooltip>
                        );
                    }
                    break;
                case "skuId":
                    row.minWidth = 200;
                    row.type = 'string';
                    row.valueGetter = params => {
                        return params.row.skuId ? params.row.skuId : "NA"
                    };
                    row.renderCell = params => {
                        return (
                            <Tooltip title={params.row.skuId ? params.row.skuId : "NA"}>
                                <Typography>{params.row.skuId ? params.row.skuId : "NA"}</Typography>
                            </Tooltip>
                        )
                    }
                    break;
                case "currentWeight":
                    row.minWidth = 150;
                    row.type = 'number';
                    row.renderCell = params => {
                        return (
                            <Tooltip title={params.row.currentWeight > 0 ? params.row.currentWeight : 0}>
                              <Typography>{Number(params.row.currentWeight) > 0 ? Number(params.row.currentWeight) : 0}</Typography>
                            </Tooltip>
                        )
                    }
                    break;
                case "currentFineWeight":
                    row.minWidth = 150;
                    row.type = 'number';
                    row.renderCell = params => {
                        return (
                            <Tooltip title={params.row.currentFineWeight > 0 ? params.row.currentFineWeight : 0}>
                              <Typography>{params.row.currentFineWeight > 0 ? params.row.currentFineWeight : 0}</Typography>
                            </Tooltip>
                        )
                    }
                    break;
                case "availableStock":
                    row.minWidth = 150;
                    row.type = 'number';
                    row.renderCell = params => {
                        return params.row.availableStock ? params.row.availableStock : "NA"
                    }
                    break;
                case "dimensions":
                    row.minWidth = 100;
                    row.type = 'string';
                    row.valueGetter = params => {
                        return params.row.dimensions ? params.row.dimensions : "NA"
                    };
                    row.renderCell = params => {    
                        return (
                            <Tooltip title={params.row.dimensions ? params.row.dimensions : "NA"}>
                              <Typography>{params.row.dimensions ? params.row.dimensions : "NA"}</Typography>
                            </Tooltip>
                        )
                    }
                    break;
                case "shape":
                    row.minWidth = 100;
                    row.type = 'string';
                    row.valueGetter = params => {
                        return params.row.shape ? params.row.shape : "NA"
                    };
                    row.renderCell = params => {
                        return (
                            <Tooltip title={params.row.shape ? params.row.shape : "NA"}>
                              <Typography>{params.row.shape ? params.row.shape : "NA"}</Typography>
                            </Tooltip>
                        )
                    }
                    break;
                case "quantity":
                    row.minWidth = 100;
                    row.type = 'number';
                    row.renderCell = params => {
                        return (
                            <Tooltip title={params.row.quantity > 0 ? params.row.quantity : 0}>
                              <Typography>{params.row.quantity > 0 ? params.row.quantity : 0}</Typography>
                            </Tooltip>
                        )
                    }
                    break;
                case "purity":
                    row.minWidth = 100;
                    row.type = 'number';
                    row.renderCell = params => {
                        return (
                            <Tooltip title={params.row.purity ? params.row.purity : "NA"}>
                              <Typography>{params.row.purity ? params.row.purity : "NA"}</Typography>
                            </Tooltip>
                        )
                    }
                    break;
                case "transactionDetails":
                    row.minWidth = 150;
                    row.filterable = false;
                    row.valueGetter = params => {
                        let transactionDetails = params.row.transactionDetails
                        return transactionDetails ? `${transactionDetails['globalTransactionNumber']}_${transactionDetails.transactionType}` : "NA"
                    };
                    row.renderCell = params => {
                        let transactionDetails = params.row.transactionDetails
                        return <>{transactionDetails ?
                          <Tooltip title='View transaction Details'>
                            <IconButton style={{ marginLeft: '-10px' }} onClick={() => setShowTranscationDetail(transactionDetails)}><VisibilityIcon /></IconButton>
                          </Tooltip> : "NA"
                        }</>
                    }
                    break;
                case "metalType":
                    row.minWidth = 100;
                    row.type = 'string';
                    row.renderCell = params => {
                        return (
                            <Tooltip title={params.row.metalType ? params.row.metalType : "NA"}>
                              <Typography>{params.row.metalType ? params.row.metalType : "NA"}</Typography>
                            </Tooltip>
                        )
                    }
                    break;
                case "serialNumbers":
                    row.minWidth = 130;
                    row.filterable = false;
                    row.valueGetter = params => {
                        return params.row.serialNumbers ? params.row.serialNumbers : "NA"
                    };
                    row.renderCell = params => {
                        return <>{params.row.inventoryType === 1 && JSON.parse(params.row.serialNumbers) ?
                          <Tooltip title='View Serial Numbers'>
                            <IconButton style={{ marginLeft: '-10px' }} onClick={() => setShowSerialNumberModal(params.row)}><VisibilityIcon /></IconButton>
                          </Tooltip> : "NA"
                        }</>
                    }
                    break;
                default:
                    row.minWidth = 100
                    break;
            }

            return row;
        })
    }

    const reloadInventory = (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
        execute(() => fetchInventory({ channelId: user.centerId! }))
    }

    useEffect(() => {
        if(user.centerId) {
            execute(() => fetchInventory({ channelId: user.centerId ?? '' }))

            let body = {
                channelId: user.centerId! ?? '',
                page: 0,
                pageSize: 25,
            }
            execute(() => fetchStoInventory(body))
        }
    }, [user.centerId])
    console.log("Inventory data ::", inventories)

    const CustomToolbar = () => {
        return (
          <GridToolbarContainer>
            <GridToolbarExport csvOptions={{ fileName: 'Inventory' }} />
          </GridToolbarContainer>
        )
    }
    
    return (
        <div style={{ padding: '0 10px' }}>
            <div style={{ borderBottom: '1px solid #d8d8d8', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                <Title style={{ textAlign: 'left', margin: '20px 10px 10px 10px', color: '#7f7d76' }}>Inventory Showcase</Title>
                <Button color="primary" variant='contained' onClick={() => setShowSTOModal('true')} disabled={!inventories?.data}>{'Create new STO'}</Button>
                <Button color="primary" variant='contained' onClick={() => setShowIssueModal('true')} disabled={!inventories?.data}>{'Issue Cut-bar'}</Button>
                <div style={{ display: 'flex', alignItems: 'center', color: '#7f7d76' }}>
                    <Tooltip title="refresh inventory">
                        <IconButton onClick={reloadInventory}>
                            <Refresh />
                        </IconButton>
                    </Tooltip>
                    <p style={{ marginLeft: '20px'}}>Last Updated At: {lastUpdatedAt}</p>
                </div>
            </div>
            <Table 
                getRowId={(row) => row.id} 
                columns={getInventoryColumns()} 
                rows={inventories?.data || []} 
                disableRowSelectionOnClick={true}
                slots={{ toolbar: CustomToolbar }} 
            />
            <Modal open={typeof showTranscationDetail != 'boolean'} title={'View Transcation Details'} onClose={closeTranscationDetailModal} maxWidth={'xl'}>
                <ShowTranscationDetails data={showTranscationDetail} />
            </Modal>
            <Modal open={typeof showSerialNumberModal != 'boolean'} title={'view Serial Numbers'} onClose={closeSerialNumberModal} maxWidth={'xl'}>
                <ShowSerialNumbers data={showSerialNumberModal} />
            </Modal>
            <Modal open={typeof showSTOModal != 'boolean'} title={'Create new STO'} onClose={closeSTOModal} maxWidth={'xl'}>
                <CreateStockModal onClose={closeSTOModal} />
            </Modal>
            <Modal open={typeof showIssueModal != 'boolean'} title={'Issue Cut-bar'} onClose={closeIssueModal} maxWidth={'xl'}>
                <IssueCutBar onClose={closeIssueModal} />
            </Modal>
        </div>
    )
}

export function ShowTranscationDetails({ data }: TranscationData) {
    return (
        <div style={{ display: 'flex', padding: '10px 0', gap: '10px', flexDirection: 'column', width: '100%', minWidth: '550px' }}>
            {Object.entries(data).map(([key, value]) => (
            <div style={{ width: '100%', display: 'flex', borderRadius: '10px', background: '#f5f5f5', border: '1px solid #d4d4d4' }}>
                <span style={{ width: '50%', background: '#e1e1e1', padding: '10px', borderRadius: '10px 0 0 10px' }}>
                    <Typography variant='body1'>{transcationFields[key] as string}</Typography>
                </span>
                <span style={{ width: '50%', padding: '10px' }}>
                    <Typography variant='body1'>{(key === 'createdAt' || key === 'updatedAt') ? moment(value).clone().utcOffset('+05:30').format('hh:mm a, Do MMM, YYYY') : value || 'NA'} </Typography>
                </span>
            </div>
        ))}
        </div>
    )
}

export function getInventoryType(rowValue: any) {
    if (rowValue && rowValue.inventoryType) {
      if (rowValue.inventoryType !== 4) {
        return InventoryType[rowValue.inventoryType];
      } else {
        if (
          rowValue.transactionDetails?.transactionType &&
          [TRANSACTION_TYPES.BUY_BACK, TRANSACTION_TYPES.BUY_SELL].includes(
            rowValue.transactionDetails.transactionType
          )
        ) {
          return Boolean(
            rowValue.transactionDetails.transactionType ===
              TRANSACTION_TYPES.BUY_BACK
          )
            ? "Scrap from buyback"
            : "Scrap from buysell";
        } else {
          return "NA";
        }
      }
    } else {
      return "NA";
    }
}

export function ShowSerialNumbers({ data }: SerialNumbers) {
    let { skuId, name, currentWeight, unitWeight, quantity, metalType, serialNumbers } = data as InventoryData

    const [rows, setRows] = useState<any>([])
    const [paginationModel, setPaginationModel] = useState({
        pageSize: 10,
        page: 0,
    })
    
    useEffect(() => {
        JSON.parse(serialNumbers).forEach((item: any, idx: any) => {
            let newRow = {
                id: idx,  
                skuId: skuId, 
                name: name,
                unitWeight: currentWeight ? Number((currentWeight / quantity).toFixed(3)) : unitWeight,
                metalType: metalType,
                serialNumber: item
            }
            setRows((prev: any) => [...prev, newRow as any])
        })
    }, [])

    let columns: GridColDef[] = [
        {
            field: "skuId",
            headerName: "SKU ID",
            minWidth: 180,
            renderCell: (params: any) => {
                return params.row.skuId
            }
        },
        {
            field: "name",
            headerName: "SKU Name",
            minWidth: 250,
            renderCell: (params: any) => {
              return params.row.name
            }
        },
        {
            field: "unitWeight",
            headerName: "Unit Weight (gm)",
            minWidth: 150,
            renderCell: (params: any) => {
              return params.row.unitWeight
            }
        },
        {
            field: "metalType",
            headerName: "Metal Type",
            minWidth: 150,
            renderCell: (params: any) => {
              return params.row.metalType
            }
        },
        {
            field: "serialNumber",
            headerName: "Serial Number",
            minWidth: 120,
            renderCell: (params: any) => {
                return params.row.serialNumber
            }
        },
    ]

    return <SerialNumberGrid>
        <DataGrid 
            getRowId={(row) => row.id} 
            rows={rows} 
            columns={columns} 
            pagination={true}
            paginationMode={"client"}
            rowHeight={40}
            paginationModel={paginationModel}
            onPaginationModelChange={setPaginationModel}
            slots={{toolbar: GridToolbar}} 
            sx={{
                ".MuiDataGrid-columnHeaders": { 
                    background: 'var(--primary_color_light)', 
                    borderRadius: '0' 
                }, 
                border: 'none', 
                borderRadius: '0'
            }}
        />
    </SerialNumberGrid>
}